module.exports = __webpack_public_path__ + "static/media/product-by-dizzain.8039d879.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Copyright/product-by-dizzain.svg
// module id = 97
// module chunks = 0